<template>
  <div id="app">
    <AppHeader />
    <main>
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style lang="scss">
// Import Sass color module
@use "sass:color";

// Import Bootstrap
@import 'bootstrap/dist/css/bootstrap.min.css';
@import '@fortawesome/fontawesome-free/css/all.min.css';

// Global styles
:root {
  --primary-color: #2c3e50;
  --secondary-color: #3498db;
  --accent-color: #f1c40f;
  --text-color: #333;
  --light-color: #f8f9fa;
  --dark-color: #343a40;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--text-color);
  line-height: 1.6;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
  margin-bottom: 1rem;
}

main {
  min-height: 70vh;
}

.container {
  padding: 2rem 1rem;
}

.btn-primary {
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);

  &:hover {
    background-color: color.adjust(#3498db, $lightness: -10%);
    border-color: color.adjust(#3498db, $lightness: -10%);
  }
}
</style>